import { useEffect } from 'react'

// metaタグの title と description にページ番号を追加するカスタムフック
export const useMetaWithPage = (currentPage, currentTab, titlePrefix) => {
  useEffect(() => {
    const title = document.title.split('|')
    const description = document.querySelector('meta[name="description"]')

    const isHome = currentTab.name === 'home'
    const resolvedTitlePrefix = isHome ? titlePrefix : `${currentTab.label}の${titlePrefix}`
    const descPrefix = isHome ? '' : `${currentTab.label}の`
    const pageStr = currentPage > 1 ? `（${currentPage}ページ目）` : ''

    document.title = `${resolvedTitlePrefix}${pageStr} | ${title[1] ? title[1].trim() : ''}`
    if (description) {
      if (!description.getAttribute('data-original-description')) {
        description.setAttribute('data-original-description', description.content)
      }
      const originalDesc = description.getAttribute('data-original-description') || ''
      description.content = `${descPrefix}${originalDesc}`
    }
  }, [currentPage, currentTab, titlePrefix])
}
